/*=========================================================================================
  File Name: i18nServiceTVAN.js
  Description: File đa ngôn ngữ cho phân hệ dịch vụ TVAN MISA
  ----------------------------------------------------------------------------------------
  Project Name: MISA mTax
	Author: NVANH3
==========================================================================================*/

export default {
	TitleForm: 'Thông tin sử dụng dịch vụ T-VAN MISA',
	TaxDec: 'Khai thuế',
	TaxPay: 'Nộp thuế',
	AlertChange: 'Tờ khai thay đổi thông tin đang chờ cơ quan thuế duyệt.',
	TaxPaySubtitle:
		'Mã số thuế chưa đăng ký sử dụng dịch vụ nộp thuế qua T-VAN',
	TaxDecSubtitle:
		'Mã số thuế chưa đăng ký sử dụng dịch vụ khai thuế qua T-VAN',
	RegisHistory: 'Lịch sử đăng ký',
	StopService: 'Ngừng dịch vụ',
	ChangeService: 'Đăng ký thay đổi',
	RegisNow: 'Đăng ký ngay',
	TaxReturn: 'Mã số thuế/CCCD',
	CASerial: 'Số seri',
	CAAdviser: 'Nhà cung cấp',
	CATime: 'Thời gian hiệu lực',
	FullName: 'Họ tên',
	PhoneNumber: 'Số điện thoại',
	Role: 'Chức danh',
	Email: 'Email',
	InfoContactMore: 'Thông tin liên hệ bổ sung',
	AddContactMore: 'Thêm',
	NoteUsingUsbToken1: 'Vui lòng cắm',
	NoteUsingUsbToken2: 'USB token',
	NoteUsingUsbToken3: 'trước khi nhấn chọn chứng thư số',
	SelectCASerialAgain: 'Chọn lại chứng thư số',
	SelectCASerial: 'Chọn chứng thư số',
	Cancel: 'Hủy bỏ',
	Next: 'Tiếp tục',
	Back: 'Quay lại',
	HeaderStep1: 'Đăng ký chứng thư số',
	HeaderStep2: 'Đăng ký tài khoản ngân hàng NTĐT',
	HeaderStep3: 'Đăng ký thông tin liên hệ',
	HeaderStep4: 'Đăng ký dịch vụ T-VAN MISA',
	NextStep1: '(1/3)',
	NextStep2: '(2/3)',
	NextStep3: '(3/3)',
	NoteContactInfoReal: 'Thông tin liên hệ chính',
	NoteContactInfoFake: 'Thông tin liên hệ bổ sung',
	NoteBankInfo: 'Thông tin đăng ký là thông tin ngân hàng thực hiện nộp thuế',
	SelectBank: 'Chọn ngân hàng',
	BankCode: 'Số tài khoản',
	BankName: 'Tên ngân hàng',
	AccountName: 'Tên chủ tài khoản',
	AlertCADate:
		'Thời hạn hiệu lực của CTS đã hết hạn. </br>Vui lòng kiểm tra lại',
	AlertDecCADate:
		'Thời hạn hiệu lực của CTS của khai thuế đã hết hạn. </br>Vui lòng kiểm tra lại',
	AlertPayCADate:
		'Thời hạn hiệu lực của CTS của nộp thuế đã hết hạn. </br>Vui lòng kiểm tra lại',
	AlertCASerial: 'Chứng thư số không được bỏ trống. Vui lòng kiểm tra lại',
	AlertDecCASerial:
		'Chứng thư số của khai thuế không được bỏ trống. Vui lòng kiểm tra lại',
	AlertPayCASerial:
		'Chứng thư số của nộp thuế không được bỏ trống. Vui lòng kiểm tra lại',

	// i18n cho màn hình xem trước tờ khai đăng ký
	CHXHCNVN: 'CỘNG HOÀ XÃ HỘI CHỦ NGHĨA VIỆT NAM',
	DLTDHP: 'Độc lập - Tự do - Hạnh phúc',
	TaxReport: 'TỜ KHAI',
	RegisTVAN: 'Đăng ký sử dụng dịch vụ T-VAN',
	StopServiceTVAN: 'Đăng ký ngừng sử dụng dịch vụ T-VAN',
	ChangeServiceTVAN:
		'Thay đổi, bổ sung thông tin đăng ký sử dụng dịch vụ T-VAN',
	Group: 'Tổ chức',
	Personal: 'Cá nhân',
	Change: 'Thay đổi',
	Updated: 'Bổ sung',
	DK01TVAN: 'Mẫu số: 01/ĐK-T-VAN',
	DK02TVAN: 'Mẫu số: 02/ĐK-T-VAN',
	DK03TVAN: 'Mẫu số: 03/ĐK-T-VAN',
	TT19Circular:
		'Ban hành kèm theo Thông tư số 19/2021/TT-BTC ngày 18/3/2021 của Bộ trưởng Bộ Tài chính',
	TT110:
		'Ban hành kèm theo Thông tư số 110/TT-BTC ngày 28/07/2015 của Bộ tài chính',
	TT19:
		'Ban hành kèm theo Thông tư số 19/2021/TT-BTC ngày 18/3/2021 của Bộ trưởng Bộ Tài chính',
	TaxAgentEmployee: 'NHÂN VIÊN ĐẠI LÝ THUẾ',
	TaxAgentName: 'Họ và tên:',
	TaxAgentCertNo: 'Chứng chỉ hành nghề số:',

	// i18n cho TT19 - Redesign
	ElectronicTransactionCheckbox:
		'Người nộp thuế đã đăng ký giao dịch với cơ quan thuế bằng phương thức điện tử thông qua Cổng thông tin điện tử của Tổng cục Thuế và đăng ký ngừng giao dịch với cơ quan thuế',
	SendToTax: 'Kính gửi: Cục thuế',
	TaxPayerNameNum: '1. Tên người nộp thuế:',
	TaxCodeNum: '2. Mã số thuế/CCCD:',
	AddressNum: '3. Địa chỉ:',
	TaxAgentInfo4: '4. Thông tin về đại lý thuế (nếu có):',
	TaxAgentName4a: '4a. Tên:',
	TaxAgentTaxCode4b: '4b. Mã số thuế:',
	TaxAgentContract4c: '4c. Hợp đồng đại lý thuế:',
	TaxAgentContractDate: 'ngày',
	TaxAgentContractNumber: 'Số',
	LegalBasis1: 'Căn cứ quy định tại Luật Quản lý thuế ngày 13/6/2019;',
	LegalBasis2:
		'Căn cứ quy định tại Thông tư số 19/2021/TT-BTC ngày 18/3/2021 của Bộ trưởng Bộ Tài chính hướng dẫn giao dịch điện tử trong lĩnh vực thuế.',
	ServiceRegistrationStatement:
		'Đăng ký được sử dụng dịch vụ thuế điện tử qua tổ chức cung cấp dịch vụ T-VAN với cơ quan thuế, cụ thể như sau:',
	SectionA: 'A. THÔNG TIN ĐĂNG KÝ CỦA NGƯỜI NỘP THUẾ',
	CAInfoSection1:
		'1. Thông tin đăng ký chứng thư số sử dụng giao dịch thuế điện tử:',
	BankInfoSection2:
		'2. Thông tin đăng ký tài khoản ngân hàng thực hiện thủ tục nộp thuê điện tử:',
	EmailInfoSection3: '3. Thông tin đăng ký địa chỉ thư điện tử:',
	EmailMainAddress31:
		'3.1. Địa chỉ thư điện tử nhận tất cả các quyết định, thông báo, văn bản khác của cơ quan thuế trong quá trình thực hiện giao dịch điện tử với cơ quan thuế:',
	EmailAdditionalAddress32:
		'3.2. Địa chỉ thư điện tử khác nhận quyết định, thông báo, văn bản khác của cơ quan thuế theo từng thủ tục hành chính thuế:',
	PhoneInfoSection4: '4. Thông tin đăng ký số điện thoại:',
	TaxPayerCommitmentTT19:
		'Người nộp thuế chịu trách nhiệm về tính hợp pháp, đầy đủ, chính xác với các thông tin đăng ký nêu trên và cam kết nhận các phản hồi, quyết định, thông báo và văn bản khác của cơ quan thuế bằng phương thức điện tử qua địa chỉ thư điện tử đã đăng ký./.',
	ViewStopServiceCommitmentTT19: 'Người nộp thuế cam kết chịu trách nhiệm hoàn toàn trước pháp luật về tính chính xác, trung thực của nội dung nêu trên./.',
		SendTo: 'Kính gửi:',
	CompanyName: 'Tên người nộp thuế:',
	RegisCondition:
		'Xét các điều kiện thực hiện giao dịch điện tử trong lĩnh vực thuế, chúng tôi nhận thấy có đủ điều kiện giao dịch với cơ quan thuế bằng phương thức điện tử. Chúng tôi đăng ký với cơ quan thuế được sử dụng dịch vụ thuế điện tử qua tổ chức cung cấp dịch vụ T-VAN, cụ thể như sau',
	StopServiceCondition:
		'Đăng ký ngừng sử dụng dịch vụ T-VAN, cụ thể như sau:',
	ChangeCondition: 'Đăng ký thay đổi, bổ sung thông tin, cụ thể như sau:',
	PayerInfo: 'I. THÔNG TIN NGƯỜI NỘP THUẾ',
	TimeStarted: '1. Thời gian đề nghị được áp dụng từ:',
	CASerialInfo:
		'2. Thông tin đăng ký chứng thư số sử dụng giao dịch điện tử:',
	CASerialInfo1:
		'1. Thông tin đăng ký chứng thư số sử dụng giao dịch điện tử:',
	CASerialInfo1Change:
		'1. Thông tin đăng ký thay đổi, bổ sung chứng thư số sử dụng giao dịch thuế điện tử:',
	BankInfo:
		'3. Thông tin đăng ký tài khoản thực hiện thủ tục nộp thuế điện tử:',
	BankInfo2:
		'2. Thông tin đăng ký tài khoản thực hiện thủ tục nộp thuế điện tử:',
	BankInfo2Change:
		'2. Thông tin đăng ký thay đổi, bổ sung tài khoản ngân hàng thực hiện thủ tục nộp thuế điện tử:',
	EmailInfo: '4. Địa chỉ thư điện tử:',
	EmailInfoReal:
		'4.1. Địa chỉ thư điện tử chính thức nhận tất cả các thông báo trong quá trình thực hiện giao dịch điện tử với cơ quan thuế:',
	EmailInfoMore:
		'4.2. Địa chỉ thư điện tử bổ sung theo mỗi thủ tục hành chính thuế:',
	EmailInfo2: '2. Địa chỉ thư điện tử:',
	EmailInfo2Change:
		'2. Thông tin đăng ký thay đổi, bổ sung địa chỉ thư điện tử đăng ký:',
	EmailInfo3: '3. Địa chỉ thư điện tử:',
	EmailInfoReal2:
		'2.1. Địa chỉ thư điện tử nhận tất cả các quyết định, thông báo, văn bản khác của cơ quan thuế trong quá trình thực hiện giao dịch điện tử với cơ quan thuế: ',
	EmailInfoMore2:
		'2.2. Địa chỉ thư điện tử khác nhận quyết định, thông báo, văn bản khác của cơ quan thuế theo từng thủ tục hành chính thuế: ',
	EmailInfoReal3:
		'3.1. Địa chỉ thư điện tử nhận tất cả các quyết định, thông báo, văn bản khác của cơ quan thuế trong quá trình thực hiện giao dịch điện tử với cơ quan thuế: ',
	EmailInfoMore3:
		'3.2. Địa chỉ thư điện tử khác nhận quyết định, thông báo, văn bản khác của cơ quan thuế theo từng thủ tục hành chính thuế: ',
	Phone: '5. Số điện thoại:',
	Phone3: '3. Số điện thoại:',
	Phone3Change: '3. Thông tin số điện thoại đăng ký thay đổi:',
	Phone4: '4. Thông tin số điện thoại đăng ký thay đổi:',
	TVANAdviser: 'II. THÔNG TIN VỀ TỔ CHỨC CUNG CẤP DỊCH VỤ T-VAN:',
	TVANAdviserTT19: 'B. THÔNG TIN VỀ TỔ CHỨC CUNG CẤP DỊCH VỤ T-VAN:',
	AdviserName: 'Tên tổ chức: Công ty cổ phần MISA',
	AdviserTaxCode: 'Mã số thuế: 0101243150',
	AdviserAddress:
		'Địa chỉ: Tầng 9 tòa nhà Technosoft, phố Duy Tân, Dịch Vọng Hậu, Cầu Giấy, Hà Nội',
	AdviserPhone: 'Số điện thoại: 024 3795 9595',
	Recommend:
		'Chúng tôi cam kết nhận các phản hồi, thông báo của cơ quan thuế bằng phương thức điện tử. Chúng tôi chịu trách nhiệm về tính hợp pháp, đầy đủ, chính xác với các thông tin đăng ký nêu trên./.',
	RecommendStop:
		'Người nộp thuế cam đoan những thông tin kê khai nêu trên là hoàn toàn chính xác và cam kết chịu trách nhiệm trước pháp luật về các thông tin đã khai./.',
	SignAdviser: 'TỔ CHỨC CUNG CẤP DỊCH VỤ T-VAN',
	SignPayer1: 'NGƯỜI NỘP THUẾ hoặc',
	SignPayer2: 'ĐẠI DIỆN HỢP PHÁP CỦA NGƯỜI NỘP THUẾ',
	Date: 'Ngày',
	Month: 'tháng',
	Year: 'năm',
	SignAndSend: 'Ký và gửi',
	RegisSuccess: 'Đăng ký dịch vụ TVAN thành công',
	RegisGNT: 'Nộp giấy nộp tiền thành công',
	RegisGNTAuthorized: 'Nộp giấy nộp tiền nộp thay thành công',
	ChangeSuccess: 'Đăng ký thay đổi dịch vụ TVAN thành công',
	StopServiceSuccess: 'Đăng ký ngừng dịch vụ TVAN thành công',
	BankSuccess: 'Đăng ký bổ sung ngân hàng thành công',
	BankStopSuccess: 'Đăng ký ngừng ngân hàng thành công',
	SubtitleContactAdditional:
		'Liên hệ bổ sung sẽ nhận các thông báo dịch vụ khai thuế từ MISA',
	NameContact: 'Tên liên hệ',
	AddContactAdditional: 'Thêm liên hệ bổ sung',
	EditContactAdditional: 'Sửa liên hệ bổ sung',
	AddContactSuccess: 'Thêm mới liên hệ bổ sung thành công',
	ErrorContactSuccess: 'Đã có lỗi xảy ra. Vui lòng kiểm tra lại',
	DeleteContactAdditional: 'Bạn có chắc chắn muốn xóa liên hệ này?',
	DeleteContactSuccess: 'Xóa liên hệ bổ sung thành công',
	DeleteContactError: 'Xóa liên hệ bổ sung không thành công',
	EditContactSuccess: 'Sửa liên hệ bổ sung thành công',
	EditContactError: 'Sửa liên hệ bổ sung không thành công',
	AccountNo: 'Số tài khoản',
	AddBank: 'Bổ sung ngân hàng',
	StopBank: 'Ngừng ngân hàng',
	InfoTax: 'Thông tin liên hệ',
	CASerialNo: 'Chứng thư số',
	TaxPayBank: 'Tài khoản nộp thuế',
	ErrorUpdateLate: 'Tính năng đang được phát triển.',
	TitleRegisNow:
		'Mã số thuế chưa đăng ký sử dụng dịch vụ thuế điện tử qua T-VAN MISA',
	TitleRegisWaitingBoth: 'Tờ khai đăng ký sử dụng dịch vụ đang chờ duyệt',
	TitleRegisWaiting:
		'Tờ khai đăng ký sử dụng dịch vụ đang chờ cơ quan thuế duyệt',
	TitleRegisWaitingBank:
		'Tờ khai đăng ký sử dụng dịch vụ đang chờ ngân hàng duyệt',
	ErrorUpdateTaxDec: 'Tính năng khai thuế đang được phát triển.',
	ErrorChooseLastOne: 'Vui lòng chọn dịch vụ đăng ký sử dụng',
	ChangeCA: 'Đăng ký thay đổi chứng thư số',
	ChangeContact: 'Đăng ký thay đổi thông tin liên hệ',
	NextStep11: '(1/1)',
	NextStep12: '(1/2)',
	NextStep22: '(2/2)',
	ChangeSelectPayTax: 'Thay đổi thông tin sử dụng dịch vụ nộp thuế',
	ChangeSelectDecTax: 'Thay đổi thông tin sử dụng dịch vụ khai thuế',
	ErrorSelectLastOne: 'Vui lòng chọn đăng ký muốn thay đổi',
	ErrorSelectNewSignature: 'Vui lòng chọn chứng thư số',
	TitleStopService: 'Ngừng sử dụng dịch vụ T-VAN MISA',
	ChangeCACheckbox: 'Thay đổi thông tin chứng thư số',
	ChangeContactCheckbox: 'Thay đổi thông tin liên hệ',
	TaxDecCheckbox: 'Khai thuế',
	TaxPayCheckbox: 'Nộp thuế',
	TimeStop: 'Thời điểm ngừng',
	ReasonStop: 'Lý do ngừng',
	ToDate: 'Từ ngày',
	RegisStopBank: 'Đăng ký ngừng ngân hàng',
	RegisNewBank: 'Đăng ký bổ sung ngân hàng',
	SubtitleStopBank:
		'Lưu ý: Đăng ký ngừng dịch vụ ngân hàng sẽ ngừng toàn bộ các tài khoản của ngân hàng đó.',
	RegisHistoryTitle: 'Lịch sử đăng ký dịch vụ',
	SelectTaxType: 'Chọn thủ tục muốn ngừng',
	StopDate: 'Thời điểm ngừng',
	Reason: 'Lý do',
	AlertSelectTaxType: 'Vui lòng chọn thủ tục muốn ngừng',
	AlertReasonEmpty: 'Lý do không được bỏ trống',
	AlertEndServiceDateEmpty: 'Thời điểm ngừng không được bỏ trống',
	InfoRegis: 'Thông tin đã đăng ký',
	InfoChange: 'Thông tin thay đổi',
	SerialChange: 'Chứng thư thay đổi',
	SerialRegis: 'Chứng thư đã đăng ký',
	CAIssuerTable: 'Tên tổ chức/cơ quan chứng thực/cấp/công nhận chữ ký số',
	CASerialTable: 'Số seri chứng thư số',
	CASerialTableTT19: 'Số sê-ri chứng thư số',
	CADateTable: 'Thời hạn sử dụng chứng thư số',
	CATaxTypeTable: 'Thủ tục thuế điện tử đăng ký sử dụng',
	CATaxTypeTableChange: 'Thủ tục hành chính thuế đăng ký sử dụng',
	CAFromDateTable: 'Từ ngày',
	CAToDateTable: 'Đến ngày',
	BankTable: 'Ngân hàng',
	BankNameTable: 'Tên chủ tài khoản',
	BankNameTableTT19: 'Tên tài khoản',
	AddBankCode: 'Mã ngân hàng',
	AddBankName: 'Tên ngân hàng',
	SubmissionName: 'Bản đăng ký',
	WaitingChange:
		'Tờ khai đăng ký thay đổi/bổ sung đang chờ cơ quan thuế duyệt',
	WaitingChangeToBank:
		'Tờ khai đăng ký thay đổi/bổ sung thông tin đang chờ ngân hàng duyệt',
	WaitingStop: 'Tờ khai đăng ký ngừng dịch vụ đang chờ cơ quan thuế duyệt',
	WaitingBankChange:
		'Tờ khai đăng ký thay đổi/bổ sung đang chờ cơ quan thuế duyệt',
	WaitingBankStop:
		'Tờ khai đăng ký thay đổi/bổ sung đang chờ cơ quan thuế duyệt',
	EmailContactAdditional: 'Địa chỉ thư điện tử',
	NameContactAdditional: 'Họ tên người sử dụng',
	TypeContactAdditional: 'Thủ tục thuế điện tử đăng ký sử dụng',
	ErrorSelectEmailContactAdditional:
		'Email liên hệ bổ sung không được phép trùng nhau',
	RegisTaxSuccess: 'Nộp tờ khai đăng ký dịch vụ thành công',
	CommentRegisTaxPaySuccess:
		'Lưu ý hoàn thành thủ tục đăng ký dịch vụ nộp thuế điện tử như sau',
	View: 'Xem',
	ViewHistoryStep: 'để theo dõi tình trạng tờ khai',
	SuggestRegisToBank1:
		'Sau khi tờ khai được chấp nhận, bạn cần đăng ký dịch vụ trực tiếp tại ',
	SuggestRegisToBank2: '. Xem hướng dẫn đăng ký',
	SuggestRegisToBank3: 'tại đây',
	TooltipHelpViewHistory:
		'Theo dõi tình trạng tờ khai đăng ký dịch vụ tại đây',
	WarningChangeTaxPay:
		'Các chức năng nộp thuế sẽ tạm thời bị khóa trong lúc chờ phê duyệt. Bạn có muốn tiếp tục?',
	WarningChangeTaxDec:
		'Các chức năng khai thuế sẽ tạm thời bị khóa trong lúc chờ phê duyệt. Bạn có muốn tiếp tục?',
	WarningStopService: 'Bạn có chắc chắn muốn đăng ký ngừng dịch vụ?',
	MesWarningStopBank:
		'Bạn chỉ có 01 ngân hàng Nộp thuế điện tử. Nếu bạn đăng ký ngừng ngân hàng sẽ ngừng luôn dịch vụ Nộp thuế điện tử qua T-VAN MISA.',
	MesPleaseWaringStopBank:
		'Vui lòng đăng ký bổ sung ngân hàng trước khi ngừng ngân hàng hiện tại.',
	ErrorStopService:
		'Vui lòng đăng ký ngừng ngân hàng trước khi đăng ký ngừng dịch vụ. Bạn có muốn đăng ký ngừng ngân hàng?',
	RegisAdditional: 'Đăng ký bổ sung',
	WarningService: '*Lưu ý:',
	SubtitleStopService: 'Khi ngừng dịch vụ sẽ ngừng tất cả các ngân hàng',
	CommentRegisTaxDecSuccess:
		'Vui lòng theo dõi tình trạng tờ khai và nhận thông báo từ cơ quan thuế.',
	SearchHistory: 'Nhập mã giao dịch, bản đăng ký, trạng thái để tìm kiếm',
	AffectWhenAddBank:
		'Bạn đang đăng ký bổ sung ngân hàng. Trong quá trình chờ duyệt đăng ký, tạm thời bạn sẽ không thể thực hiện chức năng này. Vui lòng thử lại sau',

	// i18n cho mẫu TT19
	TaxAgentInfoSection: 'Thông tin về đại lý thuế (nếu có):',
	TaxAgentNameLabel: 'Tên:',
	TaxAgentTaxCodeLabel: 'Mã số thuế:',
	TaxAgentInfo: 'Thông tin về đại lý thuế (nếu có)',
	TaxAgentTaxCode: 'Mã số thuế',
	TaxAgentContract: 'Hợp đồng đại lý thuế:',
	ContractNumber: 'Số',
	ContractDate: 'ngày',
	LegalBasis1: 'Căn cứ quy định tại Luật Quản lý thuế ngày 13/6/2019;',
	LegalBasis2:
		'Căn cứ quy định tại Thông tư số 19/2021/TT-BTC ngày 18/3/2021 của Bộ trưởng Bộ Tài chính hướng dẫn giao dịch điện tử trong lĩnh vực thuế.',
	TaxAgentEmployee: 'NHÂN VIÊN ĐẠI LÝ THUẾ',
	EmployeeName: 'Họ và tên',
	EmployeeCertificate: 'Chứng chỉ hành nghề số',
	TaxProcedure: 'Thủ tục thuế điện tử đăng ký ngừng sử dụng',
	Address: 'Địa chỉ',

	// i18n cho ViewChangeTT19
	ChangeInfoColumn: 'Thông tin thay đổi, bổ sung',
	StopUse: 'Ngừng sử dụng',
	Additional: 'Bổ sung',
	TaxPaySubtitleHKD:
		'Hệ thống hiện chỉ hỗ trợ nộp tờ khai, chưa hỗ trợ nộp thuế điện tử qua T-VAN.',
	TitleRegisNowHKD:
		'<div>Cá nhân, hộ kinh doanh không cần đăng ký dịch vụ T-VAN để nộp tờ khai.<br/>Hệ thống hiện chỉ hỗ trợ nộp tờ khai, chưa hỗ trợ nộp thuế điện tử qua T-VAN.</div>',
	TitleCompensCertViewChangeServiceInfo: (text) => `Tờ khai đăng ký thay đổi thông tin chứng thư số ${text}`
	};
